import React, { PropsWithChildren } from "react";
import { WizardStepContextState } from "models/propTypes/wintFormPropsTypes";
import { WizardStepReducer } from "./reducer";

const initialState: WizardStepContextState = {
  index: 0,
};

export const WizardStepContext = React.createContext<WizardStepContextState>(initialState);

const WizardStepContextProvider: React.FC<PropsWithChildren<WizardStepContextState>> = (props) => {
  const [state] = React.useReducer(WizardStepReducer, { ...props });

  return <WizardStepContext.Provider value={state}>{props.children}</WizardStepContext.Provider>;
};

export default WizardStepContextProvider;
